module.exports = __webpack_public_path__ + "img/Beehive-Logo-Light.873b9ac9.svg";